import { lighten } from 'polished';

import colors from 'shared-assets/lib/colors';

export default {
  border: {
    default: `solid 1px rgba(${colors.secondaryRGB}, 0.26)`,
    error: '',
    focus: `solid 1px ${lighten(0.1, `rgba(${colors.primaryRGB}, 1)`)}`,
  },
  boxShadow: 'inset 0 0 2px rgba(0, 0, 0, 0.15)',
  borderRadius: '2px',
  padding: '4px 8px',
  text: {
    small: '13px',
    base: '16px',
    large: '19px',
  },
};

export const cardStyle = {
  background: '#fff',
  borderRadius: '2px',
  boxShadow: '0 1px 2px rgba(0,0,0,.15)',
};

export const alertBanner = {
  marginBottom: '1rem',
  color: colors.secondary,
  fontSize: '1rem',
  fontWeight: 400,
};
